import { FunctionComponent, SVGProps } from "react"

import {
  CheckmarkIcon,
  CleaningIcon,
  GuestIcon,
  MaintenanceIcon,
  NoGuestIcon,
  NotCleanIcon,
} from "@minuthq/meatball-ui-icons"

import { THome } from "src/data/homes/types/homeTypes"
import { useTranslate } from "src/i18n/useTranslate"

export function useHomeOperationalStateInfo(
  operationalState: THome["operational_state"]
):
  | {
      icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>
      color: "good" | "warning" | "info" | "neutral"
      description: string
      title: string
    }
  | undefined {
  const { t, langKeys } = useTranslate()

  if (!operationalState) {
    return undefined
  }

  switch (operationalState.status) {
    case "vacant":
      return {
        icon: NoGuestIcon,
        color: "neutral",
        title: t(langKeys.home_operational_state_vacant),
        description: t(langKeys.home_operational_state_vacant_description),
      }
    case "vacant_and_clean":
      return {
        icon: CheckmarkIcon,
        color: "good",
        title: t(langKeys.home_operational_state_clean),
        description: t(langKeys.home_operational_state_clean_description),
      }
    case "vacant_and_dirty":
      return {
        icon: NotCleanIcon,
        color: "warning",
        title: t(langKeys.home_operational_state_needs_cleaning),
        description: t(
          langKeys.home_operational_state_needs_cleaning_description
        ),
      }
    case "cleaning":
      return {
        icon: CleaningIcon,
        color: "info",
        title: t(langKeys.home_operational_state_cleaning),
        description: t(langKeys.home_operational_state_cleaning_description),
      }
    case "ongoing_maintenance":
      return {
        icon: MaintenanceIcon,
        color: "info",
        title: t(langKeys.home_operational_state_maintenance),
        description: t(langKeys.home_operational_state_maintenance_description),
      }
    case "occupied":
      return {
        icon: GuestIcon,
        color: "info",
        title: t(langKeys.home_operational_state_occupied),
        description: t(langKeys.home_operational_state_occupied_description),
      }
  }
}
